<template>
    <div>
        <div v-if="role != 'customer' && role != 'employee'" class="header">
            <button key="button"
                    v-if="!showForm"
                    class="btn btn-primary"
                    :class="{ disabled: showForm }"
                    @click="showForm = true">
                Create new draft selection
            </button>

            <!-- Button trigger modal -->
            <transition name="fade">
                <div v-if="showCreateTemplateLink" class="templateHint" key="templateHint">
                    You can also <span class="link" @click="createTemplateLink">create a material selection template</span> to reuse in future projects.
                </div>
                <button v-else-if="!loadingTemplates" key="templateButton" type="button" class="btn btn-info" data-toggle="modal" data-target="#draftTemplateModal">
                    Create draft selections from templates
                </button>
            </transition>

            <!-- Modal -->
            <div class="modal fade template-modal" id="draftTemplateModal" tabindex="-1" role="dialog" aria-labelledby="draftTemplateModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Select templates to import</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="break"></div>
                        <div>
                            <div class="link d-inline-block" @click="selectAllTemplates">
                                Select all
                            </div>
                            <div v-if="numberOfSelectedTemplates > 0" class="link d-inline-block ml-2" @click="clearAllTemplates">
                                Clear
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="list-group mb-3">
                            <button type="button" v-for="template in sortedTemplates" :key="template.id" class="list-group-item list-group-item-action pointer" :class="selectedTemplateClass(template)" @click="clickedTemplate(template)">
                                {{ template.title }}
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="clickedCreateSelectionsFromTemplates" :class="numberOfSelectedTemplates < 1 || loading ? 'disabled' : ''">Create {{ numberOfSelectedTemplates }} new {{ pluralSelectedTemplates }}</button>
                    </div>
                    </div>
                </div>
            </div>

            <transition name="fade">
                <div key="key1" v-if="showForm" class="mt-2">
                    <new-selection :project="project" :changeorders="changeorders" :isDraft="true"></new-selection>
                </div>
            </transition>
        </div>

        <div v-if="loading" class="card card-default">
            <div class="card-header">
                <span class="loading-text">Loading...</span>
                <span class="loader float-right"></span>
            </div>
        </div>

        <div v-else-if="error" class="card card-default">
            <div class="card-header">
                <div class="">
                    <div><strong>Well, this is embarrassing.</strong> Something went wrong.</div>
                    <div>Please try refreshing the page, or otherwise <a href="mailto:support@sitecommandapp.com?subject=Help!">get in touch</a> and we'll be happy to help!
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <caught-up-message v-if="(role == 'customer' || role == 'employee') && !loading && changeorders.length == 0" :object="'material selections'"></caught-up-message>
            <selection v-else v-for="changeorder in sortedSelections" :role="role" :user="user" :key="changeorder.id" :changeorder="changeorder" :project="project"></selection>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
            this.getDrafts();
            this.getTemplates();
            this.registerEvents();
        },

        mounted: function() {

        },

        data: function() {
            return {
                showForm: false,
                changeOrderCreated: false,
                changeorders: [],
                templates: [],
                countPending: 0,
                totalPending: 0,
                total: 0,
                loading: true,
                error: false,
                loadingTemplates: true,
                showReleasedMessage: false,
                releasedDraft: null
            };
        },

        watch: {
            project: function (newProject, oldProject) {
                this.refresh();
            }
        },

        computed: {
            sortedTemplates: function() {
                return _.sortBy(this.templates, template => {
                    return template.title;
                });
            },

            sortedSelections: function() {
                return _.sortBy(this.changeorders, changeorder => {
                    return changeorder.title;
                });
            },

            pluralSelectedTemplates: function() {
                if (this.numberOfSelectedTemplates == 1) {
                    return 'draft selection';
                }
                return 'draft selections'
            },

            numberOfSelectedTemplates: function() {
                let count = 0;
                for (var index in this.templates) {
                    let template = this.templates[index];
                    if (template.selected) count++;
                }
                return count;
            },

            showCreateTemplateLink: function() {
                return !this.loadingTemplates && this.templates.length == 0;
            }
        },

        methods: {
            createTemplateLink: function() {
                $('a[href="#templates"]').trigger('click');
            },

            clickedCreateSelectionsFromTemplates: function() {
                this.createDraftSelectionsFromTemplates();
            },

            selectedTemplateClass: function(template) {
                return template.selected ? 'active' : '';
            },

            clickedTemplate: function(template) {
                template.selected = !template.selected;
                Vue.set(this.templates, this.templates.indexOf(template), template);
            },

            clearAllTemplates: function() {
                _.forEach(this.templates, template => {
                    template.selected = false;
                    Vue.set(this.templates, this.templates.indexOf(template), template);
                });
            },

            selectAllTemplates: function() {
                _.forEach(this.templates, template => {
                    template.selected = true;
                    Vue.set(this.templates, this.templates.indexOf(template), template);
                });
            },

            registerEvents: function() {
                var vm = this;
                Bus.$on('new-draft-selection-created', function (response) {
                    vm.newSelectionCreated(response);
                    return true;
                });
                Bus.$on('new-draft-selection-canceled', function (response) {
                    vm.showForm = false;
                    return true;
                });
                Bus.$on('draft-selection-updated', function (response) {
                    vm.selectionUpdated(response);
                    return true;
                });
                Bus.$on('draft-selection-deleted', function(response) {
                    vm.selectionDeleted(response.id);
                    return true;
                });
                Bus.$on('new-template-created', function (response) {
                    vm.getTemplates();
                    return true;
                });
                Bus.$on('template-updated', function (response) {
                    vm.getTemplates();
                    return true;
                });
                Bus.$on('template-deleted', function(response) {
                    vm.getTemplates();
                    return true;
                });
            },

            newSelectionCreated: function(changeorder) {
                this.changeOrderCreated = true;
                this.showForm = false;
                this.changeorders.unshift(changeorder);
            },

            selectionDeleted: function(deletedChangeOrderId) {
                for (var index in this.changeorders) {
                    var changeorder = this.changeorders[index];
                    if (changeorder.id == deletedChangeOrderId) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.delete(this.changeorders, this.changeorders.indexOf(changeorder));
                        break;
                    }
                }

                if (this.changeorders.length == 0) {
                    this.showForm = true;
                }
            },

            selectionUpdated: function(updateChangeOrder) {
                for (var index in this.changeorders) {
                    var changeorder = this.changeorders[index];
                    if (changeorder.id == updateChangeOrder.id) {
                        // Use Vue.set to get reactivity when changing the contents of an array
                        Vue.set(this.changeorders, this.changeorders.indexOf(changeorder), updateChangeOrder);
                        break;
                    }
                }
            },

            prettyDate: function (date) {
                return moment.utc(date).local().fromNow();
            },

            getDrafts: function() {
                if (!this.project) {
                    return;
                }
                
                this.changeorders = [];
                axios.get(`/api/selections/drafts/${this.project.id}`)
                    .then(response => {
                        this.loading = false;
                        this.error = false;
                        this.changeorders = response.data.changeorders;
                        this.total = response.data.total;
                        this.totalPending = response.data.totalPending;
                        this.countPending = response.data.countPending;

                        if (this.changeorders.length == 0) {
                            this.showForm = true;
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.error = true;
                    });
            },

            refresh: function() {
                this.loading = true;
                this.getDrafts();
            },

            getTemplates: function() {    
                this.loadingTemplates = true;
                axios.get(`/api/templates`)
                    .then(response => {
                        this.loadingTemplates = false;
                        this.templates = response.data.templates;
                    })
                    .catch(error => {
                        this.loadingTemplates = false;
                    });
            },

            createDraftSelectionsFromTemplates: function() {
                let selectedTemplates = _.filter(this.templates, template => {
                    if (template.selected) return template;
                });

                if (selectedTemplates.length == 0) return;

                this.loading = true;
                $('#draftTemplateModal').modal('hide')

                let templateIds = _.map(selectedTemplates, 'id');
                let templateUrl = `/api/selections/drafts/templates`;
                axios.post(templateUrl, {
                    project_id: this.project.id,
                    templates: templateIds
                })
                .then(response => {
                    this.clearAllTemplates();
                    this.refresh();
                    this.showForm = false;
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error);
                });
            }
        }
    }
</script>
